var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Quote"},[_c('div',{staticClass:"Quote_Container"},[_c('p',[_vm._v(_vm._s(("\"" + (_vm.$t(_vm.currentQuote)) + "\"")))]),_c('img',{attrs:{"src":require('../../../assets/pantelleria/signature-blanche.svg')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }